import React from 'react';
import { useTranslation } from 'react-i18next';
import { useResto } from '../../contexts/RestoContext';

const StandardFooter = () => {
  const { t } = useTranslation();
  const { restoData } = useResto();
  
  return (
    <div className="text-center background-main-color-70" style={{ color: 'rgba(255,255,255,0.7)' }}>
      <p className="mb-0">&copy; {new Date().getFullYear()} { restoData.label }. { t('COPYRIGHT') }</p>
    </div>
  );
}

export default StandardFooter;
